<template lang="pug">
    .height-100
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .title
          span Auditoria
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .filtros-container(key="filtros-container")
            transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
              .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
                h2.text filtros
                .caret
                  span.icon
                    i.fa.fa-caret-down(v-if="mostrarFiltros")
                    i.fa.fa-caret-up(v-else)

              .filtros(v-if="mostrarFiltros", key="filtros")
                .filtro
                  .codigo-empleado
                    .control.title-singular
                      p Empleado
                      .input-container
                        input.input(
                          type="number",
                          v-model="filtroCodigoEmpleado"
                          @focus="mostrarBusquedaEmpleado = true"
                          :disabled="true"
                        )
                        span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                          i.fa.fa-search
                        .erase-data(@click="limpiarEmpleado")
                          .icon
                            .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaEmpleado"
                        )
                          lookup-small-empleado(
                            @selected="seleccionarEmpleado"
                            @close="mostrarBusquedaEmpleado = false"
                            :codigo="filtroCodigoEmpleado"
                          )
                .filtro
                  .lookup
                    .control.title-singular
                      p Módulo
                      .input-container
                        input.input(
                          type="text",
                          v-model="filtroModulo"
                          @focus="mostrarBusquedaModulo = true"
                          :disabled="true"
                        )
                        span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaModulo = true")
                          i.fa.fa-search
                        .erase-data(@click="limpiarModulo")
                          .icon
                            .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaModulo"
                        )
                          lookup-actividades-modulo(
                            @selected="seleccionarModulo"
                            @close="mostrarBusquedaModulo = false"
                            :codigo="filtroModulo"
                          )

                .filtro
                  .lookup
                    .control.title-singular
                      p Acciones
                      .input-container
                        input.input(
                          type="text",
                          v-model="filtroAccion"
                          @focus="mostrarBusquedaAccion = true"
                          :disabled="true"
                        )
                        span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaAccion = true")
                          i.fa.fa-search
                        .erase-data(@click="limpiarAccion")
                          .icon
                            .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaAccion"
                        )
                          lookup-actividades-acciones(
                            @selected="seleccionarAccion"
                            @close="mostrarBusquedaAccion = false"
                            :codigo="filtroAccion"
                          )

                .filtro
                  .lookup
                    .control.title-singular
                      p Desde
                      .input-container.display-flex
                        input.input(
                          type="date",
                          v-model="desde"
                          @blur="fetch"
                        )
                .filtro
                  .lookup
                    .control.title-singular
                      p Hasta
                      .input-container.display-flex
                        input.input(
                          type="date",
                          v-model="hasta"
                          @blur="fetch"
                        )

              .boton-container(key="boton-container")
                button.button(@click="fetch")
                  span.icon.is-small
                    i.fa.fa-refresh.fa-fw.fa-lg
                  span Refrescar
                button.button(@click="limpiarFiltros")
                  span.icon.is-small
                    i.fa.fa-trash.fa-fw.fa-lg
                  span Limpiar
          .body(key="body")
            .information
              transition-group.contenedor-data(
                v-infinite-scroll="fetchByScroll"
                infinite-scroll-disabled="disabledScrollExecute"
                infinite-scroll-distance="2"
                name="fade-smooth-two"
                tag="div"
              )
                .is-desktop(key="is-desktop")
                  table.table.is-striped.is-bordered(
                    v-if="lista.length !== 0"
                  )
                    thead
                      th Descripcion
                      th Perfil
                      th Módulo
                      th Datos
                    tbody(
                      name="table-row"
                      is="transition-group"
                    )
                      tr.row-table(
                        v-for="(o, index) in lista"
                        :key="index"
                      )
                        td
                          span.hint--top.inline(:aria-label="'log: ' + o.id") {{ o.descripcion || o.accion }}&nbsp;
                          span.hint--top.has-text-bold(:aria-label="o.fechaString") {{   o.fecha | fromNow }}
                        td {{ o.perfil || o.usuario | capitalize}}
                        td
                          span.hint--top(:aria-label="'ID relacionado: ' + o.idRelacionado") {{ o.modulo | capitalize}}
                        td
                          div
                            span.has-text-bold Accion:&nbsp;
                            span.hint--top.tipo-icon(:aria-label="o.tipo")
                              i(:class="tipoIcon[o.tipo]")
                          div(v-for="(value, key) in o.datos")
                            span.has-text-bold {{  key | capitalize }}:&nbsp;
                            span {{  value }}
                .is-mobile(key="is-mobile")
                  .box(
                    v-for="(o, index) in lista"
                    :key="index"
                  )
                    .status
                      span {{ o.perfil || o.usuario | capitalize}}
                    .perfil
                    .descripcion-tipo.hint--top(:aria-label="'ID relacionado: ' + o.idRelacionado")
                      span.has-text-bold {{ o.modulo.toUpperCase() }}
                    .motivo.hint--bottom(:aria-label="'Log: ' + o.id")
                      span.has-text-bold {{ o.descripcion || o.accion }} {{   o.fecha | fromNow }}
                      div.has-text-lef.datos-auditoria
                        div
                          span.has-text-bold Accion:&nbsp;
                          span.hint--top.tipo-icon(:aria-label="o.tipo")
                            i(:class="tipoIcon[o.tipo]")
                        div(v-for="(value, key) in o.datos")
                          span.has-text-bold {{  key | capitalize }}:&nbsp;
                          span {{  value }}
                      .fecha {{ o.fechaString }}
            .is-loading(v-if="isLoading")
              .icon
                i.fa.fa-spinner.fa-spin
            .message.is-warning(v-if="lista.length === 0 && !isLoading")
              .message-body
                span.has-text-bold No existe información con los filtros definidos
</template>

  <script>
  import LookupSmallEmpleado from '../components/Component_Lookup_Small_Empleado'
  import LookupActividadesModulo from '../components/lookups/Actividades_Modulo'
  import LookupActividadesAcciones from '../components/lookups/Actividades_Acciones'
  import moment from 'moment'
  import { apiGet, notify } from '../util/general'

  export default {
    name: 'auditoria',
    data () {
      return {
        lista              : [],
        isLoading          : false,
        tipoIcon:{
          'guardar'        : 'fa fa-save',
          'enviar'          : 'fa fa-check',
          'aprobar'        : 'fa fa-check',
          'rechazar'       : 'fa fa-times',
          'desactivar'     : 'fa fa-times',
          'no lo tomo'     : 'fa fa-times',
          'notificar'      : 'fa fa-envelope',
          'editar'         : 'fa fa-edit',
          'adjuntar'       : 'fa fa-paperclip',
          'ver'            : 'fa fa-eye',
          'firmar'       : 'fa fa-pencil'
        },
        mostrarFiltros            : true,
        mostrarBusquedaEmpleado   : false,
        mostrarBusquedaModulo     : false,
        mostrarBusquedaAccion     : false,
        filtroModulo              : '',
        filtroAccion              : '',
        filtroCodigoEmpleado      : '',
        desde                     : '',
        hasta                     : '',
        perfiles : [
          'usuario',
          'jefe',
          'recursos humanos'
        ],
        isScroll               : false,
        disabledScrollExecute : true,
        skip                   : 0,
        noMore                 : false
      }
    },
    components: {
      LookupSmallEmpleado,
      LookupActividadesModulo,
      LookupActividadesAcciones
    },
    computed : {
      showSidebarDesktop () {
        return this.$store.getters.showSidebarDesktop
      }
    },
    mounted () {
      this.hasta = moment().format('YYYY-MM-DD')
      this.desde = moment().subtract(1, 'day').format('YYYY-MM-DD')
      this.fetch()
    },
    methods: {
      fetchByScroll () {
        var vm = this
        vm.isScroll = true
        vm.fetch()
      },
      fetch () {
        var vm = this
        vm.isLoading = true
        vm.disabledScrollExecute = true
        vm.noMore = false
        var obj = {}
        if (vm.filtroCodigoEmpleado) obj.codigoEmpleado = vm.filtroCodigoEmpleado
        if (vm.filtroModulo) obj.modulo = vm.filtroModulo
        if (vm.filtroAccion) obj.accion = vm.filtroAccion
        if (vm.desde && vm.hasta) {
          obj.desde = vm.desde
          obj.hasta = vm.hasta
        }
        if (!vm.isScroll) {
          vm.lista = []
          vm.skip = 0
        }
        obj.skip = vm.skip
        apiGet(vm, '/auditoria', obj, function (data) {
          // poner a las fechas este formato 2018-01-01 00:00:00 con moment
          data.lista.forEach(function (o) {
            // o.fecha = moment(o.fecha).format('DD/MM/YYYY HH:mm:ss')
            o.datos = JSON.parse(o.datos)
            vm.lista.push(o)
          })
          if (data.noMore) {
            vm.noMore = true
            vm.disabledScrollExecute = true
          } else {
            vm.skip += data.lista.length
            vm.disabledScrollExecute = false
          }
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.isLoading = false
          vm.isScroll = false
        })
      },
      seleccionarEmpleado (o) {
        this.filtroCodigoEmpleado = o.codigo
        this.fetch()
      },
      seleccionarModulo (o) {
        this.filtroModulo = o.modulo
        this.fetch()
      },
      seleccionarAccion (o) {
        this.filtroAccion = o.accion
        this.fetch()
      },
      limpiarFiltros () {
        this.filtroCodigoEmpleado = ''
        this.filtroModulo         = ''
        this.filtroAccion         = ''
        this.hasta = moment().format('YYYY-MM-DD')
        this.desde = moment().subtract(1, 'day').format('YYYY-MM-DD')
        this.fetch()
      },
      limpiarEmpleado () {
        this.filtroCodigoEmpleado = ''
        this.fetch()
      },
      limpiarModulo () {
        this.filtroModulo = ''
        this.fetch()
      },
      limpiarAccion () {
        this.filtroAccion = ''
        this.fetch()
      }
    }
  }
  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="stylus" scoped>
    .contenedor-interno
      .close
        float right
        cursor pointer
        i
          font-size 16px

      .title
        font-size 16px
        span
          font-weight bold
          text-transform uppercase

    th
      text-align center

    .row-table
      transition all 0.3s ease
      &.is-close
        background-color #ffd6d6 !important


    .table-row-enter, .table-row-leave-active {
      opacity: 0
      height 0
    }

    .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      min-width: 300px
      width: 100%;
      z-index: 70;
      top 0

    .position-relative
      position relative

    .codigo-empleado
      position relative
      .control
        .input-container
          display flex
          align-items center
          .input
            flex 1
            width 100px
          .erase-data
            cursor pointer
            margin-left 5px
    .lookup
      position relative
      .control
        .input-container
          display flex
          align-items center
          .input
            flex 1
            width 100px
          .erase-data
            cursor pointer
            margin-left 5px

    .filtros-container
      padding-bottom 10px
      border-bottom 1px solid #ccc
      .title-filtro
        display flex
        text-align left
        padding 10px
        margin-bottom 10px
        border-bottom 1px solid #ccc
        .text
          text-transform uppercase
          flex 1
        .caret
          cursor pointer

      .filtros
        margin-bottom 10px
        text-align left
        display flex
        align-items: flex-start;


        .filtro
          // width 100%
          display inline-block
          border 1px solid #cccccc
          background-color #f9f9f9
          padding 5px
          margin 5px
          border-radius 3px
          flex 1
          .title-singular
            text-align left
            font-weight bold
            user-select: none
          .abierto-cerrado-container
            display flex
            .option
              padding 4px
              border 1px solid #565cde
              color #565cde
              cursor pointer
              transition all 0.3s ease
              height 31.5px

              &.selected
                background-color: #565cde;
                color: #fff;

          .list-container
            padding 0px 10px 0px 10px
            .option
              user-select: none
              cursor pointer
              &.selected
                color #565cde
                font-weight bold

    .boton-container
      button
        margin-left 5px



    .is-loading
      margin-top 10px

    .information
      padding-top 10px

    th
      vertical-align: middle;
    td
      vertical-align: middle;

    td
      .email
        font-size 12px
        color #9a9a9a

    .table
      font-size 13px

    .td-status
      width: 50px;

    .status
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .circle
        width: 25px;
        height: 25px;
        border-radius: 50%
        transition background ease-in .15s
        border 1px solid #d8d8d8
        background-color #23d160
        &.green
          background-color #23d160
        &.yellow
          background-color #ffdd57
        &.red
          background-color #ff0000
        &.white
          background-color #ffffff

    .status-container-filtro
      display flex
      justify-content center
      align-items center
      .status
        margin 5px
        cursor pointer
        .circle
          transition all ease-in .15s
          width: 30px;
          height: 30px;
        &.selected
          .circle
            border 2px solid #565cde

    .tipo-icon
      i
        font-size 14px
        vertical-align middle

    .contenedor-acciones
      display flex
      justify-content space-around
      .button
        flex 1
        margin 0px 5px
    .is-mobile
      display none
      .box
        position: relative;
      .status
        position:absolute;
        top: 3px
        right: 7px
        span {
          font-size: 10px;
          color #a5a5a5
          font-weight: bold;
          text-transform: uppercase;
        }
        i
          margin-left: 4px
      .perfil
        position:absolute;
        top: 3px
        left: 10px
        span {
          font-size: 10px;
          font-weight: bold;
          text-transform: uppercase;
        }
      .descripcion-tipo
        margin-top: 10px;
        margin-bottom 5px
      .motivo
        background-color: #eff5fb;
        color: #296fa8;
        padding: 10px
        display flex
        flex-direction column
        align-items center
        position relative

        .datos-auditoria
          width: fit-content
          text-align: left
          font-size: 11px
          padding-top 5px
          padding-bottom 10px
          i
            font-size 11px

        .fecha
          position absolute
          bottom 2px
          right 4px
          font-size 11px

    .modal-sidebar-desktop-open
      width: calc(100% - 180px);

    @media (max-width: 1036px)
      .filtros
        flex-direction column
        .filtro
          width 100%
    @media (max-width: 820px)
      .modal-sidebar-desktop-open
        width: 100%;
    @media (max-width 578px)
      .is-mobile
        display block

      .is-desktop
        display none

    @media (max-width 450px)
      .table
        font-size 12px
  </style>




// WEBPACK FOOTER //
// View_Auditoria.vue?216d7bd3